import api from "src/rest/api";
import {
  ProtocolLI,
  ProtocolType,
} from "../../../fithub-shared/interfaces/protocol";
import { ExerciseTemplate } from "../../../fithub-shared/interfaces/templates";

export let currentProtocol: ProtocolType;
export let exercisesList: ExerciseTemplate[];

export async function GetPlansList(student_id?: string) {
  if (!student_id) return [];

  return await api
    .post("/protocols/list", {
      student_id: student_id,
    })
    .then((res) => {
      const _protocols = res.data as ProtocolLI[];
      return _protocols;
    })
    .catch(() => {
      return [] as ProtocolLI[];
    });
}

export async function GetPlanTemplates() {
  return await api
    .post<ProtocolLI[]>("/protocols/list/templates")
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return [] as ProtocolLI[];
    });
}

export function StoreProtocol(protocol: ProtocolType) {
  protocol.autosave = true;
  localStorage.setItem(`${protocol.id}`, JSON.stringify(protocol));
}

export async function UploadProtocolData(protocol: ProtocolType) {
  protocol.autosave = false;

  RemoveLocal(protocol.id);

  return await api
    .post("/protocols/save", protocol)
    .then(() => {
      return true;
    })
    .catch((err) => {
      return false;
    });
}

export function GetLocal(id: string) {
  return localStorage.getItem(`${id}`) !== null;
}

export function RemoveLocal(id: string) {
  localStorage.removeItem(`${id}`);
}

/*
toda vez que carregar a lista de protocolos
preciso verificar se existe no async storage;
caso exista, ao invés de puxar o protocolo do banco de dados,
ele vai puxar do async storage. então vai ser {id do protocolo}
*/

export const LoadProtocol = (id: string): Promise<ProtocolType> => {
  return new Promise((resolve, reject) => {
    api
      .post<ProtocolType>(`/protocols/get`, { id: id })
      .then((res) => {
        const current = { ...res.data };

        resolve(current);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
